export const SEPARATOR = { separator: true };
